import type { TRuleWithTheme } from '@/styles/theme';

export const contentContainer: TRuleWithTheme = () => ({
    width: '100%',

    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',

    paddingBlock: '2rem',
    paddingInline: '1rem',

    gap: '1rem',

    // To prevent the chat button from overlapping the content
    paddingBottom: '8rem',

    min1024: {
        paddingTop: '0.75rem',
        paddingBottom: '3rem',
        paddingInline: '4.25rem',

        gap: '2rem',
    },
});
